import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { adminApi, adminToken, errMsg } from "@/lib/api";
import { audio } from "@/lib/audio";
import { toast } from "sonner";
import { PaperButton } from "@/components/paper";
import { Lock, ShieldAlert } from "lucide-react";

export default function AdminLogin() {
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e?.preventDefault();
    setBusy(true);
    try {
      const { data } = await adminApi.post("/admin/login", { email: email.trim(), password });
      adminToken.set(data.token);
      audio.play("success");
      nav("/admin");
    } catch (err) { toast.error(errMsg(err, "Invalid email or password.")); audio.play("error"); }
    setBusy(false);
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-4">
      <form onSubmit={submit} className="card-paper p-8 w-full max-w-md" data-testid="admin-login-form">
        <div className="flex items-center gap-2 mb-1"><ShieldAlert strokeWidth={2.5} /><span className="font-hand font-bold text-sm text-ink2">RESTRICTED</span></div>
        <h1 className="font-hand font-bold text-4xl">LOSTDC CONTROL CENTER</h1>
        <p className="font-semibold text-ink2 mt-1 mb-5">Administrator sign in.</p>
        <label className="font-hand font-bold">Email</label>
        <input data-testid="admin-email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} className="w-full mt-1 mb-3 card-flat px-4 py-3 font-semibold outline-none focus-mark" placeholder="admin@lostdc.com" />
        <label className="font-hand font-bold">Password</label>
        <input data-testid="admin-password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} className="w-full mt-1 mb-5 card-flat px-4 py-3 font-semibold outline-none focus-mark" placeholder="••••••••" />
        <PaperButton data-testid="admin-login-submit" type="submit" color="#FFDD2D" className="w-full text-xl" disabled={busy}><Lock size={18} strokeWidth={2.5} className="inline mr-2" />{busy ? "Signing in…" : "SIGN IN"}</PaperButton>
      </form>
    </div>
  );
}
